import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AxiosError } from 'axios';
import { RunTransition, WorkflowService } from 'src/app/shared/services/workflow/workflow.service';
import { errorResponse } from 'src/types/error-response';

@Component({
  selector: 'app-generate-attorney-data-dialog',
  templateUrl: './generate-attorney-data-dialog.component.html',
  styleUrls: ['./generate-attorney-data-dialog.component.scss']
})
export class GenerateAttorneyDataDialogComponent {
  loading = false;
  errorMessages: Record<string, string[]> = {};

  constructor(
    private workflowService: WorkflowService,
    private dialogRef: MatDialogRef<GenerateAttorneyDataDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RunTransition,
    private snackbar: MatSnackBar,
  ) { }

  async submit(): Promise<void> {
    if (this.loading) {
      return;
    }

    try {
      this.loading = true;
      this.errorMessages = {};
      await this.workflowService.runTransition(this.data);
      this.dialogRef.close();
    } catch (error: AxiosError | unknown) {
      if (error instanceof AxiosError) {
        const errorResponseData = errorResponse.safeParse(error.response?.data);
        if (errorResponseData.success) {
          this.errorMessages = errorResponseData.data.errors;
          return;
        }

        if (error.response?.data?.message) {
          this.snackbar.open(error.response.data.message, 'OK', { duration: 5000 });
          return;
        }
      }

      this.snackbar.open('Ismeretlen hiba!', 'OK', { duration: 5000 });
    } finally {
      this.loading = false;
    }
  }
}
